import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Table, Card, Avatar, Button, Link, Pagination, Spin } from 'components/elements';
import Axios from 'axios';
import { BASE_URL, PAGE_SIZE } from '../../../inc/constants';
import { getAPIDefaultHeaders, handleCatch, handleEntityDelete, serialize } from '../../../inc/functions';
import { Input } from '../../../components/elements';

const ProductList = ({ className }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
	  page: 1
  });
  const columns = [
    {
      title: 'تصویر',
      dataIndex: 'primary_image',
      render: img => img && <Avatar src={img.thumbnail} />,
    },
    {
      title: 'عنوان',
      dataIndex: 'name',
    },
    {
      title: 'دسته‌بندی',
      dataIndex: 'category',
      render: (c) => c && <Link to={`/categories/${c.id}/edit/`}>{c.name}</Link>,
    },
    {
      title: 'اسلاگ',
      dataIndex: 'slug',
    },
    {
      title: 'توضیحات',
      dataIndex: 'description',
      render: (d) => d && d.length > 50 ? d.substr(0, 50) + '...' : d,
    },
	{
		title: 'فعال',
		dataIndex: 'is_active',
		render: i => i ? 'فعال' : 'غیرفعال'
	},
    {
      title: '',
      dataIndex: 'id',
      render: id => (
        <>
          <Link to={`/products/${id}/edit/`}>
            <Button small secondary>ویرایش</Button>
          </Link>
          <Button onClick={() => handleEntityDelete('products', id, 'محصول', setLoading, load)} small error>حذف</Button>
        </>
      ),
    },
    
  ];

  useEffect(() => {
	loadCategories();
  }, [])
  useEffect(() => {
    load();
  }, [filters]);

  const loadCategories = () => {
    Axios.get(`${BASE_URL}/admin/categories/?size=1000&parent__isnull=false`, getAPIDefaultHeaders()).then((res) => {
      setCategories(res.data.results);
    }).catch((err) => {
      handleCatch(err);
    });
  };

  const load = () => {
    setLoading(true);
    Axios.get(`${BASE_URL}/admin/products/?${serialize(filters)}`, getAPIDefaultHeaders()).then((res) => {
      setData(res.data);
      setLoading(false);
    }).catch((err) => {
      handleCatch(err);
      setLoading(false);
    });
  };

  const cardMeta = (
    <div style={{textAlign: 'left', display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
		<Input.Select placeholder="فیلتر دسته بندی" options={categories?.map(cat => ({
			label: cat.name,
			value: cat.id
		}))} onChange={evt => { setFilters({...filters, page: 1, category: evt.target.value}); console.log(evt.target.value) }} />
      <Link to="/products/new/">
        <Button small>محصول جدید</Button>
      </Link>
    </div>
  );

  return (
    <Card title="محصولات" meta={cardMeta}>
      <Spin active={loading}>
        <Table dataSource={data?.results || []} columns={columns} />
        <Pagination count={data?.count || 0} current={filters?.page} onChange={p => setFilters(ff => ({...ff, page: p}))}/>
      </Spin>
    </Card>
  );
};

const StyledProductList = styled(ProductList)`
`;

export default StyledProductList;
